import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WorkspaceCategoriesDataGrid } from "src/components/views/workspaces/WorkspaceCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/workspace/categories")({
	staticData: { title: i18n.t("categories"), legacyViewKey: "workspaceCategoriesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WorkspaceCategoriesDataGrid />;
}
